import type { PendingReceipt } from "./types";
const receiptPrefix = "commercial-registry-pending:";
export const readPending = (userId: string): PendingReceipt | null => {
  const raw = sessionStorage.getItem(receiptPrefix + userId);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as PendingReceipt;
    return typeof value.idempotencyKey === "string" &&
      typeof value.sentAt === "string"
      ? value
      : null;
  } catch {
    return null;
  }
};
/** 法人情報は保存しない応答喪失後の照会に必要なキーと送信日時だけ保持する */
export const savePending = (userId: string, receipt: PendingReceipt): void => {
  sessionStorage.setItem(receiptPrefix + userId, JSON.stringify(receipt));
};
export const removePending = (userId: string): void => {
  sessionStorage.removeItem(receiptPrefix + userId);
};
